"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _helpers = _interopRequireDefault(require("./helpers"));
var _helpers2 = require("../helpers");
var _misc = require("../../misc");
var _Icon = _interopRequireDefault(require("../../icon/Icon"));
var _Minimum = _interopRequireDefault(require("./Minimum"));
var _Maximum = _interopRequireDefault(require("./Maximum"));
var _Placeholder = _interopRequireDefault(require("./Placeholder"));
var _FormulaRange = _interopRequireDefault(require("./FormulaRange.style"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var initialFormula = function initialFormula(_ref) {
  var formula = _ref.formula,
    rule = _ref.rule,
    ruleChange = _ref.ruleChange;
  ruleChange('complex', _objectSpread(_objectSpread({}, rule.complex), {}, _defineProperty({}, rule.complex.activeType, _objectSpread(_objectSpread({}, R.path(['complex', rule.complex.activeType], rule)), {}, {
    minimum: formula,
    maximum: formula
  }))));
};
var FormulaRange = function FormulaRange(props) {
  var disabled = props.disabled,
    rule = props.rule,
    labels = props.labels,
    ruleIndex = props.ruleIndex,
    ruleChange = props.ruleChange,
    actions = props.actions,
    setHasChanges = props.setHasChanges,
    placeholderLabel = props.placeholderLabel;
  var activeType = R.path(['complex', 'activeType'], rule);
  return /*#__PURE__*/_react["default"].createElement(_FormulaRange["default"], {
    "data-testid": "formula-range-wrapper"
  }, R.length(R.path(['complex', activeType, 'minimum'], rule)) ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "formula-range-body"
  }, /*#__PURE__*/_react["default"].createElement(_misc.MenuList, {
    position: "top-right",
    disabled: disabled,
    menuItems: (0, _helpers["default"])({
      labels: labels,
      actions: actions,
      ruleIndex: ruleIndex,
      setHasChanges: setHasChanges
    }),
    ignoreSingleItemLogic: true
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "ion-android-more-vertical"
  })), /*#__PURE__*/_react["default"].createElement(_Minimum["default"], props), /*#__PURE__*/_react["default"].createElement(_Maximum["default"], props)) : /*#__PURE__*/_react["default"].createElement(_Placeholder["default"], {
    label: placeholderLabel,
    disabled: disabled,
    createInitialFormula: R.compose(function (formula) {
      return initialFormula({
        formula: formula,
        rule: rule,
        ruleChange: ruleChange
      });
    }, _helpers2.createInitialFormula)
  }));
};
FormulaRange.defaultProps = {
  disabled: false
};
FormulaRange.propTypes = {
  disabled: _propTypes["default"].bool,
  ruleIndex: _propTypes["default"].number.isRequired,
  rule: _propTypes["default"].shape({}).isRequired,
  labels: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,
  ruleChange: _propTypes["default"].func.isRequired,
  actions: _propTypes["default"].shape({
    deleteRuleRange: _propTypes["default"].func.isRequired
  }).isRequired,
  setHasChanges: _propTypes["default"].func.isRequired,
  placeholderLabel: _propTypes["default"].string.isRequired
};
FormulaRange.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "FormulaRange",
  "props": {
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "ruleIndex": {
      "description": "",
      "type": {
        "name": "number"
      },
      "required": true
    },
    "rule": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": true
    },
    "labels": {
      "description": "",
      "type": {
        "name": "objectOf",
        "value": {
          "name": "string"
        }
      },
      "required": true
    },
    "ruleChange": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "actions": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "deleteRuleRange": {
            "name": "func",
            "required": true
          }
        }
      },
      "required": true
    },
    "setHasChanges": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "placeholderLabel": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    }
  }
};
var _default = FormulaRange;
exports["default"] = _default;